import * as React from "react";
import "debounce";
import "tabbable";
import { usePrevious } from "../helpers/helper/hooks/use-previous.mjs";
import { getElementFontSize, isElementInline, getParentElementParameters, formatNumberToPixels } from "./helpers.mjs";
const Fittext = (props) => {
  const { className, children } = props;
  const container = React.useRef(null);
  const [fontSize, setFontSize] = React.useState(0);
  const prevChildren = usePrevious(children);
  const parentWidth = React.useRef(0);
  const resizeText = React.useCallback(() => {
    if (!container.current) {
      return;
    }
    const el = container.current;
    const elementFontSize = getElementFontSize(el);
    const width = isElementInline(el) ? el.offsetWidth : el.scrollWidth;
    const { parentFontSize, currentParentWidth } = getParentElementParameters(el);
    if (currentParentWidth && elementFontSize && parentFontSize) {
      const isChildGreaterThanParent = width > currentParentWidth + 1;
      if (isChildGreaterThanParent) {
        setFontSize((f) => {
          if (f > 1) {
            return f - 1;
          }
          return f;
        });
      }
    }
  }, []);
  const maybeResetTextSize = React.useCallback(() => {
    if (!container.current) {
      return;
    }
    const el = container.current;
    const { parentFontSize, currentParentWidth } = getParentElementParameters(el);
    if (currentParentWidth && parentFontSize) {
      const isResetRequired = parentWidth.current !== currentParentWidth;
      parentWidth.current = currentParentWidth;
      if (isResetRequired) {
        setFontSize(parentFontSize);
      }
    }
  }, []);
  React.useLayoutEffect(() => {
    resizeText();
  }, [fontSize, resizeText]);
  React.useEffect(() => {
    const resizeHandler = () => {
      maybeResetTextSize();
      resizeText();
    };
    window.addEventListener("resize", resizeHandler);
    resizeHandler();
    return () => {
      window.removeEventListener("resize", resizeHandler);
    };
  }, [resizeText, maybeResetTextSize]);
  React.useEffect(() => {
    if (prevChildren && children[0] !== prevChildren[0]) {
      const el = container.current;
      if (el) {
        const { parentFontSize, currentParentWidth } = getParentElementParameters(el);
        parentWidth.current = currentParentWidth;
        setFontSize(parentFontSize);
      }
    }
  }, [children, prevChildren]);
  const BEM = () => {
    const classArray = ["fittext"];
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  return /* @__PURE__ */ React.createElement(
    "span",
    {
      style: {
        fontSize: fontSize ? formatNumberToPixels(fontSize) : void 0
      },
      ref: container,
      className: BEM()
    },
    children
  );
};
export {
  Fittext
};
